import {useEffect, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import {euroFormat} from "../../../utils/usefullFunctions";
import CustomDataGrid from "../../table/CustomDataGrid";

const columns = [
    {name: 'name', header: 'Arbeid', defaultFlex: 1, editable: false,},
    {
        name: 'tarif', header: 'Tarief', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
        onRender: (cellProps) => {
            cellProps.style.background = '#f8f8f8'
        },
        render: ({value}) => {
            if (value) return euroFormat(value)
        },
    },
    {
        name: 'total', header: 'Totalen', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
        onRender: (cellProps) => {
            cellProps.style.background = '#f8f8f8'
        }
    },

];

// The last table, shows all sums of the hours
const HoursTotal = () => {
    const {values} = useFormikContext();
    const {service_form_project_hours_cost, service_form_project_hour_tariffs, service_form_project_articles_cost} = values


    const [dataSource, setDataSource] = useState([]);
    
    useEffect(() => {
        setDataSource([
            {
                id: 0,
                name: "DDC",
                tarif: service_form_project_hour_tariffs.oh.cost,
                total: Math.ceil(service_form_project_hours_cost.ohddc / service_form_project_hour_tariffs.oh.cost),
            },
            {
                id: 1,
                name: "VELD",
                tarif: service_form_project_hour_tariffs.oh.cost,
                total: Math.ceil(service_form_project_hours_cost.ohveld / service_form_project_hour_tariffs.oh.cost),
            },
            {
                id: 2,
                name: "PL",
                tarif: service_form_project_hour_tariffs.pl.cost,
                total: Math.ceil((service_form_project_hours_cost.pl + service_form_project_articles_cost.storing?.cost) / service_form_project_hour_tariffs.pl.cost),
            },
            {
                id: 3,
                name: "BOA",
                tarif: service_form_project_hour_tariffs.boa.cost,
                total: Math.ceil((service_form_project_hours_cost.boaBasis + service_form_project_hours_cost.boa + service_form_project_hours_cost.energy) / service_form_project_hour_tariffs.boa.cost),
            },

        ])

    }, [service_form_project_hours_cost, service_form_project_hour_tariffs, service_form_project_articles_cost])


    return <CustomDataGrid
                idProperty="id"
                editable={true}
                columns={columns}
                dataSource={dataSource}
                style={{minHeight: "100%"}}
            />
}


export default HoursTotal